export const FIRST_TIME_DEP = 'eec6ab46-e7ee-44d9-b83f-da83e3bc0131';
export const SECOND_TIME_DEP = 'b0b856f3-c3b6-4302-b779-5b747c78310b';
export const THIRD_TIME_DEP = 'a036f67f-1db3-42cd-86a5-95f9c0d28bd7';

export const TEST_SEGMENT = '68fa88ec-f11e-4c6e-bdbf-524420f52284';

export const HIDE_DEPOSITE_BONUSES = '0a65decf-7a04-4f98-8713-2dfc5a3c6459';

export const ALL_WELCOME_CLAIMED = '6ba845b7-e1d2-47e0-a971-d7c284636eda';
